import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Grid, Paper } from '@mui/material';

const ValuePropositionGrid = () => {
  const { t } = useTranslation();

  const values = [
    { title: t('value.speed_title', 'Fast & Easy'), desc: t('value.speed_desc', 'Quick processes from start to finish.') },
    { title: t('value.trust_title', 'Verified & Safe'), desc: t('value.trust_desc', 'Built-in safety and verification for all users.') },
    { title: t('value.transparency_title', 'Total Transparency'), desc: t('value.transparency_desc', 'Clear pricing, status updates, and no surprises.') }
  ];

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4, md: 8 },
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: { xs: 4, md: 6 } }}
      >
        {t('value_propositions.title', 'Why Choose Us?')}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {values.map((val, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Paper
              elevation={4}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 3,
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                {val.title}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {val.desc}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValuePropositionGrid;
